import React from 'react';

import { Button, Card, Typography } from 'antd';

import { constants } from 'helpers/constants';
import type IProduct from 'interfaces/IProduct';

import { SalePageLink } from './SalePageLink';

interface IProps {
  physicalProductPending: boolean;
  currentProduct: IProduct;
  currentUserId: number;
}

const SalesPageUrls = ({ physicalProductPending, currentProduct, currentUserId }: IProps) => {
  return (
    <Card className='mt-5 max-w-full'>
      <div className='flex flex-col gap-6'>
        <div className='flex flex-col gap-3'>
          <Typography.Title level={4} className='!mb-0'>
            Crie sua página com Orbit Pages!
          </Typography.Title>
          <Typography.Paragraph className='text-content-subtitle !mb-0'>
            Clientes Eduzz tem 3 páginas grátis! Clique no botão abaixo para começar.
          </Typography.Paragraph>
          <div>
            <Button
              type='primary'
              href={constants.links.OrbitPage}
              target='_blank'
              rel='noopener noreferrer'
            >
              Criar minhas páginas - É grátis!
            </Button>
          </div>
        </div>

        <div className='flex flex-col gap-2'>
          <Typography.Title level={5} className='!mb-0'>
            Página de vendas / Padrão Eduzz
          </Typography.Title>
          <div className='w-full max-w-md'>
            <SalePageLink
              currentProduct={currentProduct}
              currentUserId={currentUserId}
              physicalProductPending={physicalProductPending}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SalesPageUrls;
